module.exports = __webpack_public_path__ + "img/landing-page2.7d30d4fc.jpg";